import { EmbedLayout } from "./Embed/EmbedLayout";
import { StandardLayout } from "./Root/StandardLayout";
import { SurveyLayout } from "./Survey/SurveyLayout";

/**
 * The page layouts RootLayout chooses between, with the name the dev stage
 * shows and whether BackgroundDecoration renders behind them. The dev shell
 * renders each preview inside the same entry its real route uses.
 */
export const PAGE_LAYOUTS = {
  standard: {
    Layout: StandardLayout,
    name: "RootLayout",
    withBackground: true,
  },
  survey: { Layout: SurveyLayout, name: "SurveyLayout", withBackground: true },
  embed: { Layout: EmbedLayout, name: "EmbedLayout", withBackground: false },
} as const;

export type PageLayoutKind = keyof typeof PAGE_LAYOUTS;
